/** Shared access-token read for dashboard/profile fetch (session-first; legacy localStorage fallback). */
export const SESSION_EXPIRED_MESSAGE =
  'Logged out due to inactivity after 24 hours. Please sign in again.';

export function getStoredAccessToken() {
  let token =
    sessionStorage.getItem('pathbuddy_access_token') ||
    sessionStorage.getItem('access_token') ||
    sessionStorage.getItem('token') ||
    localStorage.getItem('pathbuddy_access_token');

  if (token && token.includes('pathbuddy_refresh_token')) {
    const tokenEnd = token.indexOf('pathbuddy_refresh_token');
    token = tokenEnd > 0 ? token.substring(0, tokenEnd) : token;
  }

  return token || null;
}
